// extracted by mini-css-extract-plugin
module.exports = {"button":"_32pNhGB0mqm1t3V8L7tJnu"};